export default "__VITE_ASSET__DmfX71OQ__"